// floatingMenuPlugin.js
// ProseMirror plugin for floating menu on text selection (tooltip pattern)

import {Plugin, PluginKey} from "prosemirror-state";
import {FloatingMenuTooltip} from "./floatingMenu/FloatingMenuTooltip";

export const floatingMenuKey = new PluginKey("floatingMenu");

/**
 * Create the floating menu plugin
 * @returns {Plugin}
 */
export function floatingMenuPlugin() {
    return new Plugin({
        key: floatingMenuKey,
        view(editorView) {
            return new FloatingMenuTooltip(editorView);
        }
    });
}
